import * as React from "react";

// perfect scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";

import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "#fafafa",
    flex: 1
  }
}));

const RollInfoDetails = ({ userActivity }) => {
  const classes = useStyles();
  return <PerfectScrollbar className={classes.root}></PerfectScrollbar>;
};

export default RollInfoDetails;
